export const PollResponseSubmitted = (question, response) => ({
  type: 'Responded to Poll',
  data: {
    question,
    response,
  },
});
